import { render, staticRenderFns } from "./sapProduct.vue?vue&type=template&id=31a868bb"
import script from "./sapProduct.vue?vue&type=script&lang=js"
export * from "./sapProduct.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports